import CheckMailingAddressEditForm from "./check-mailing-address-edit-form";

export const ADDRESS_VERIFY_ERROR_BANNER = {
  title: "Address verification failed",
  message:
    "We couldn’t match this mailing address on our end. Update it and verify again to request your check.",
};

export default function ValidateAddressModal({
  draft,
  onFieldChange,
  onVerify,
  onCancel,
  isVerifying = false,
  showVerifyError = false,
}) {
  return (
    <div
      className="bc-validate-address-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Validate Your Address"
    >
      <div className="bc-validate-address-dialog">
        <CheckMailingAddressEditForm
          draft={draft}
          onFieldChange={onFieldChange}
          onSave={onVerify}
          onCancel={onCancel}
          isSaving={isVerifying}
          savingLabel="Verifying…"
          title="Validate Your Address"
          subtitle="Confirm where we should mail your check. We'll verify this address before you continue."
          saveLabel="Verify Address"
          errorBanner={showVerifyError ? ADDRESS_VERIFY_ERROR_BANNER : null}
        />
      </div>
    </div>
  );
}
